import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TuiButton, TuiIcon, TuiLoader } from '@taiga-ui/core';
import { TuiBadge } from '@taiga-ui/kit';

import { DashboardLogsStatusComponent } from './dashboard-logs-status.component';

@NgModule({
  declarations: [DashboardLogsStatusComponent],
  imports: [CommonModule, TuiIcon, TuiLoader, TuiBadge, TuiButton],
  exports: [DashboardLogsStatusComponent],
})
export class DashboardLogsStatusModule {}
